<div class="createHeader">
  <img src="../../assets/images/logo/logo-blue-circle-dark.svg" alt="Indy Chamber logo" class="logo">
</div>

<div *ngIf="!onFinalStep" class="createDiv">
  <div>
    <div class="stepDiv">
      <span [ngClass]="{'stepActive': currentStep == 1}" class="stepDot"><i class="fa-solid fa-circle"></i></span>
      <span [ngClass]="{'stepActive': currentStep == 2}" class="stepDot"><i class="fa-solid fa-circle"></i></span>
      <span [ngClass]="{'stepActive': currentStep == 3}" class="stepDot"><i class="fa-solid fa-circle"></i></span>
    </div>
  </div>
  <div *ngIf="currentStep == 1 && !onFinalStep">
    <div>
      <h3 *ngIf="specialAppType && specialAppType=='startup'">Startup</h3>
      <h3 *ngIf="specialAppType && specialAppType=='chambercare'">ChamberCare Health Alliance</h3>
      <h2>Tell Us About You</h2>
    </div>
    <div>
      <form [formGroup]="stepOneForm">

        <div class="row">
          <div class="col-md-6 mb-3">
            <label for="firstName" class="form-label">Your First Name</label>
            <input formControlName="firstName" type="text" class="form-control" id="firstName" placeholder="First Name">
            <div *ngIf="firstNameCtrl.invalid && (firstNameCtrl.dirty || firstNameCtrl.touched)">
              <i class="fas fa-exclamation-circle"></i> This field is required.
            </div>
          </div>
          <div class="col-md-6 mb-3">
            <label for="lastName" class="form-label">Your Last Name</label>
            <input formControlName="lastName" type="text" class="form-control" id="lastName" placeholder="Last Name">
            <div *ngIf="lastNameCtrl.invalid && (lastNameCtrl.dirty || lastNameCtrl.touched)">
              <i class="fas fa-exclamation-circle"></i> This field is required.
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6 mb-3">
            <label for="yourEmail" class="form-label">Your Email</label>
            <input formControlName="emailAddress" type="email" class="form-control" id="yourEmail"
              placeholder="email@example.com">
            <div *ngIf="emailAddressCtrl.invalid && (emailAddressCtrl.dirty || emailAddressCtrl.touched)">
              <div *ngIf="emailAddressCtrl.errors?.required">
                <i class="fas fa-exclamation-circle"></i> This Field is Required
              </div>
              <div *ngIf="emailAddressCtrl.errors?.email">
                <i class="fas fa-exclamation-circle"></i> Must be a valid email.
              </div>
            </div>
          </div>
          <div class="col-md-6 mb-3">
            <label for="yourPhone" class="form-label">Your Phone</label>
            <input formControlName="phoneNumber" type="text" class="form-control" id="yourPhone" mask="(000) 000-0000"
              placeholder="(123) 123-1234">
            <div *ngIf="phoneNumberCtrl.invalid && (phoneNumberCtrl.dirty || phoneNumberCtrl.touched)">
              <i class="fas fa-exclamation-circle"></i> This field is required.
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6 mb-3">
            <label for="jobTitle" class="form-label">Your Job Title</label>
            <input formControlName="jobTitle" type="text" class="form-control" id="jobTitle" placeholder="Job Title">
          </div>
          <div class="col-md-6 mb-3">
            <label for="referredBy" class="form-label">I was referred to fill out this application by</label>
            <input formControlName="referredBy" type="text" class="form-control" id="referredBy"
              placeholder="Referred By">
            <!--<select formControlName="referredBy" class="form-select" aria-label="referredBy" id="referredBy">
                        <option selected>Select</option>
                        <option value="1">person</option>
                    </select>-->
          </div>
        </div>
        <div class="row" *ngIf="specialAppType == 'chambercare'">
          <div class="col-md-6 mb-3">
            <label for="brokerName" class="form-label">Broker Name</label>
            <input formControlName="brokerName" type="text" class="form-control" id="brokerName"
              placeholder="Broker Name">
            <div *ngIf="brokerNameCtrl.invalid && (brokerNameCtrl.dirty || brokerNameCtrl.touched)">
              <i class="fas fa-exclamation-circle"></i> This field is required.
            </div>
          </div>
          <div class="col-md-6 mb-3">
            <label for="brokerEmail" class="form-label">Broker Email</label>
            <input formControlName="brokerEmail" type="email" class="form-control" id="brokerEmail"
              placeholder="email@example.com">
            <div *ngIf="brokerEmailCtrl.invalid && (brokerEmailCtrl.dirty || brokerEmailCtrl.touched)">
              <div *ngIf="brokerEmailCtrl.errors?.required">
                <i class="fas fa-exclamation-circle"></i> This Field is Required
              </div>
              <div *ngIf="brokerEmailCtrl.errors?.email">
                <i class="fas fa-exclamation-circle"></i> Must be a valid email.
              </div>
            </div>
          </div>
        </div>

        <hr />

        <div class="row">
          <div class="col-md-6 mb-3">
            <label for="billingContact" class="form-label mb-4">Will you be the billing contact for this
              business?</label>
            <div class="form-check">
              <input [value]="true" [formControl]="isBillingContactCtrl" [checked]="true" class="form-check-input"
                type="radio" name="billingRadio" id="billingRadio1">
              <label class="form-check-label" for="billingRadio1">
                Yes
              </label>
            </div>
            <div class="form-check">
              <input [value]="false" [formControl]="isBillingContactCtrl" [checked]="false" class="form-check-input"
                type="radio" name="billingRadio" id="billingRadio2">
              <label class="form-check-label" for="billingRadio2">
                No
              </label>
            </div>
            <div *ngIf="isBillingContactCtrl.invalid && (isBillingContactCtrl.dirty || isBillingContactCtrl.touched)">
              <i class="fas fa-exclamation-circle"></i> This field is required.
            </div>
          </div>
          <div *ngIf="isBillingContact() == false" class="col-md-6 mb-3">
            <!-- show if no, otherwise class d-none hides -->
            <div class="row">
              <div class="col-12 mb-3">
                <label for="billingFirstName" class="form-label">Billing First Name</label>
                <input formControlName="billingContactFirstName" type="text" class="form-control" id="billingFirstName"
                  placeholder="Billing First Name">
                <div
                  *ngIf="billingFirstNameCtrl.invalid && (billingFirstNameCtrl.dirty || billingFirstNameCtrl.touched)">
                  <i class="fas fa-exclamation-circle"></i> This field is required.
                </div>
              </div>
              <div class="col-12 mb-3">
                <label for="billingLastName" class="form-label">Billing Last Name</label>
                <input formControlName="billingContactLastName" type="text" class="form-control" id="billingLastName"
                  placeholder="Billing Last Name">
                <div *ngIf="billingLastNameCtrl.invalid && (billingLastNameCtrl.dirty || billingLastNameCtrl.touched)">
                  <i class="fas fa-exclamation-circle"></i> This field is required.
                </div>
              </div>
              <div class="col-12 mb-3">
                <label for="billingEmail" class="form-label">Billing Email</label>
                <input formControlName="billingContactEmail" type="email" class="form-control" id="billingEmail"
                  placeholder="Billing Email">
                <div *ngIf="billingEmailCtrl.invalid && (billingEmailCtrl.dirty || billingEmailCtrl.touched)">
                  <div *ngIf="billingEmailCtrl.errors?.required">
                    <i class="fas fa-exclamation-circle"></i> This Field is Required
                  </div>
                  <div *ngIf="billingEmailCtrl.errors?.email">
                    <i class="fas fa-exclamation-circle"></i> Must be a valid email.
                  </div>
                </div>
              </div>
              <div class="col-12 mb-3">
                <label for="billingPhone" class="form-label">Billing Phone</label>
                <input formControlName="billingContactPhone" type="text" class="form-control" mask="(000) 000-0000"
                  id="billingPhone" placeholder="Billing Phone">
                <div *ngIf="billingPhoneCtrl.invalid && (billingPhoneCtrl.dirty || billingPhoneCtrl.touched)">
                  <i class="fas fa-exclamation-circle"></i> This field is required.
                </div>
              </div>
            </div>
          </div>
        </div>

        <hr />

        <div class="row">
          <div class="col-md-6 mb-3">
            <label for="keyContact" class="form-label mb-4">Will you be the key contact for your membership?</label>
            <div class="form-check">
              <input [value]="true" [formControl]="isKeyContactCtrl" [checked]="true" class="form-check-input"
                type="radio" name="keyContactRadio" id="keyContactRadio1">
              <label class="form-check-label" for="keyContactRadio1">
                Yes
              </label>
            </div>
            <div class="form-check">
              <input [value]="false" [formControl]="isKeyContactCtrl" [checked]="false" class="form-check-input"
                type="radio" name="keyContactRadio" id="keyContactRadio2">
              <label class="form-check-label" for="keyContactRadio2">
                No
              </label>
            </div>
            <div *ngIf="isKeyContactCtrl.invalid && (isKeyContactCtrl.dirty || isKeyContactCtrl.touched)">
              <i class="fas fa-exclamation-circle"></i> This field is required.
            </div>
          </div>
          <div class="col-md-6 mb-3">
            <!-- show if no, otherwise class d-none hides -->
            <div *ngIf="isKeyContact() == false" class="row">
              <div class="col-12 mb-3">
                <label for="keyFirstName" class="form-label">Key First Name</label>
                <input formControlName="keyContactFirstName" type="text" class="form-control" id="keyFirstName"
                  placeholder="Key Contact First Name">
                <div *ngIf="keyFirstNameCtrl.invalid && (keyFirstNameCtrl.dirty || keyFirstNameCtrl.touched)">
                  <i class="fas fa-exclamation-circle"></i> This field is required.
                </div>
              </div>
              <div class="col-12 mb-3">
                <label for="keyLastName" class="form-label">Key Last Name</label>
                <input formControlName="keyContactLastName" type="text" class="form-control" id="keyLastName"
                  placeholder="Key Contact Last Name">
                <div *ngIf="keyLastNameCtrl.invalid && (keyLastNameCtrl.dirty || keyLastNameCtrl.touched)">
                  <i class="fas fa-exclamation-circle"></i> This field is required.
                </div>
              </div>
              <div class="col-12 mb-3">
                <label for="keyEmail" class="form-label">Key Email</label>
                <input formControlName="keyContactEmail" type="email" class="form-control" id="keyEmail"
                  placeholder="Key Contact Email">
                <div *ngIf="keyEmailCtrl.invalid && (keyEmailCtrl.dirty || keyEmailCtrl.touched)">
                  <div *ngIf="keyEmailCtrl.errors?.required">
                    <i class="fas fa-exclamation-circle"></i> This Field is Required
                  </div>
                  <div *ngIf="keyEmailCtrl.errors?.email">
                    <i class="fas fa-exclamation-circle"></i> Must be a valid email.
                  </div>
                </div>
              </div>
              <div class="col-12 mb-3">
                <label for="keyPhone" class="form-label">Key Phone</label>
                <input formControlName="keyContactPhone" type="text" class="form-control" id="keyPhone"
                  placeholder="Key Contact Phone" mask="(000) 000-0000">
                <div *ngIf="keyPhoneCtrl.invalid && (keyPhoneCtrl.dirty || keyPhoneCtrl.touched)">
                  <i class="fas fa-exclamation-circle"></i> This field is required.
                </div>
              </div>
            </div>
          </div>

        </div>
      </form>
    </div>
  </div>
  <div *ngIf="currentStep == 2 && !onFinalStep">
    <div>
      <h3 *ngIf="specialAppType && specialAppType=='startup'">Silver Startup</h3>
      <h3 *ngIf="specialAppType && specialAppType=='chambercare'">ChamberCare Health Alliance</h3>
      <h2 *ngIf="specialAppType && specialAppType=='startup'">Tell Us About Your Startup</h2>
      <h2 *ngIf="specialAppType && specialAppType=='chambercare'">Tell Us About You</h2>
      <h2 *ngIf="specialAppType == null">Tell Us About Your Company</h2>
    </div>
    <div>
      <form [formGroup]="stepTwoForm">
        <div class="row">
          <div class="col-md-7 mb-3">
            <label for="companyName" class="form-label">Company/Organization Name</label>
            <input formControlName="companyName" type="text" class="form-control" id="companyName"
              placeholder="Company/Organization Name">
            <div *ngIf="companyNameCtrl.invalid && (companyNameCtrl.dirty || companyNameCtrl.touched)">
              <i class="fas fa-exclamation-circle"></i> This field is required.
            </div>
          </div>
          <div class="col-md-5 mb-3">
            <label for="employeeCount" class="form-label"># of Employees in 10 County Region</label>
            <select formControlName="numberOfEmployees" class="form-select" aria-label="employeeCount"
              id="employeeCount">
              <option selected value="-1">Select</option>
              <option *ngFor="let emp of numberOfEmpoyeesOptions" value="{{emp.value}}">{{emp.text}}</option>
            </select>
            <div
              *ngIf="numberOfEmployeesCtrl.invalid && (numberOfEmployeesCtrl.dirty || numberOfEmployeesCtrl.touched)">
              <i class="fas fa-exclamation-circle"></i> This field is required.
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6 mb-3">
            <label for="businessPhone" class="form-label">Business Phone</label>
            <input formControlName="businessPhone" type="text" class="form-control" id="businessPhone"
              placeholder="(123) 123-1234" mask="(000) 000-0000">
            <div *ngIf="businessPhoneCtrl.invalid && (businessPhoneCtrl.dirty || businessPhoneCtrl.touched)">
              <i class="fas fa-exclamation-circle"></i> This field is required.
            </div>
          </div>
          <div class="col-md-6 mb-3">
            <label for="businessAddress" class="form-label">Business Address</label>
            <input formControlName="businessAddress" type="text" class="form-control" id="businessAddress"
              placeholder="Business Address">
            <div *ngIf="businessAddressCtrl.invalid && (businessAddressCtrl.dirty || businessAddressCtrl.touched)">
              <i class="fas fa-exclamation-circle"></i> This field is required.
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6 mb-3">
            <label for="businessCity" class="form-label">City</label>
            <input formControlName="city" type="text" class="form-control" id="businessCity" placeholder="City">
            <div *ngIf="cityCtrl.invalid && (cityCtrl.dirty || cityCtrl.touched)">
              <i class="fas fa-exclamation-circle"></i> This field is required.
            </div>
          </div>
          <div class="col-md-2 mb-3">
            <label for="businessState" class="form-label">State</label>
            <select formControlName="state" class="form-select" aria-label="businessState" id="businessState">
              <option selected>Select</option>
              <option value="AL">Alabama</option>
              <option value="AK">Alaska</option>
              <option value="AZ">Arizona</option>
              <option value="AR">Arkansas</option>
              <option value="CA">California</option>
              <option value="CO">Colorado</option>
              <option value="CT">Connecticut</option>
              <option value="DE">Delaware</option>
              <option value="DC">District Of Columbia</option>
              <option value="FL">Florida</option>
              <option value="GA">Georgia</option>
              <option value="HI">Hawaii</option>
              <option value="ID">Idaho</option>
              <option value="IL">Illinois</option>
              <option value="IN">Indiana</option>
              <option value="IA">Iowa</option>
              <option value="KS">Kansas</option>
              <option value="KY">Kentucky</option>
              <option value="LA">Louisiana</option>
              <option value="ME">Maine</option>
              <option value="MD">Maryland</option>
              <option value="MA">Massachusetts</option>
              <option value="MI">Michigan</option>
              <option value="MN">Minnesota</option>
              <option value="MS">Mississippi</option>
              <option value="MO">Missouri</option>
              <option value="MT">Montana</option>
              <option value="NE">Nebraska</option>
              <option value="NV">Nevada</option>
              <option value="NH">New Hampshire</option>
              <option value="NJ">New Jersey</option>
              <option value="NM">New Mexico</option>
              <option value="NY">New York</option>
              <option value="NC">North Carolina</option>
              <option value="ND">North Dakota</option>
              <option value="OH">Ohio</option>
              <option value="OK">Oklahoma</option>
              <option value="OR">Oregon</option>
              <option value="PA">Pennsylvania</option>
              <option value="RI">Rhode Island</option>
              <option value="SC">South Carolina</option>
              <option value="SD">South Dakota</option>
              <option value="TN">Tennessee</option>
              <option value="TX">Texas</option>
              <option value="UT">Utah</option>
              <option value="VT">Vermont</option>
              <option value="VA">Virginia</option>
              <option value="WA">Washington</option>
              <option value="WV">West Virginia</option>
              <option value="WI">Wisconsin</option>
              <option value="WY">Wyoming</option>
            </select>
            <div *ngIf="stateCtrl.invalid && (stateCtrl.dirty || stateCtrl.touched)">
              <i class="fas fa-exclamation-circle"></i> This field is required.
            </div>
          </div>
          <div class="col-md-4 mb-3">
            <label for="zipPostal" class="form-label">ZIP/Postal</label>
            <input formControlName="zip" type="text" mask="00000" class="form-control" id="zipPostal"
              placeholder="ZIP/Postal">
            <div *ngIf="zipCtrl.invalid && (zipCtrl.dirty || zipCtrl.touched)">
              <i class="fas fa-exclamation-circle"></i> This field is required.
            </div>
          </div>
        </div>

        <hr />

        <div class="row">
          <div class="col-12 mb-3">
            <label for="selfIdentifyList" class="form-label mb-4">Does your business self-identify as any of the below?
              Please select all that apply.</label>

            <div class="form-check">
              <input formControlName="isAlaskanNative" class="form-check-input" type="checkbox" id="selfIdentify1">
              <label class="form-check-label" for="selfIdentify">
                Alaskan Native American Indian-Owned
              </label>
            </div>
            <div class="form-check">
              <input formControlName="isAsian" class="form-check-input" type="checkbox" id="selfIdentify2">
              <label class="form-check-label" for="selfIdentify">
                Asian-Owned
              </label>
            </div>
            <div class="form-check">
              <input formControlName="isBlack" class="form-check-input" type="checkbox" id="selfIdentify3">
              <label class="form-check-label" for="selfIdentify">
                Black-Owned
              </label>
            </div>
            <div class="form-check">
              <input formControlName="isDisability" class="form-check-input" type="checkbox" id="selfIdentify4">
              <label class="form-check-label" for="selfIdentify">
                Disability-Owned
              </label>
            </div>
            <div class="form-check">
              <input formControlName="isHispanic" class="form-check-input" type="checkbox" id="selfIdentify5">
              <label class="form-check-label" for="selfIdentify">
                Hispanic-Owned
              </label>
            </div>
            <div class="form-check">
              <input formControlName="isLgbtq" class="form-check-input" type="checkbox" id="selfIdentify6">
              <label class="form-check-label" for="selfIdentify">
                LGBTQ+-Owned
              </label>
            </div>
            <div class="form-check">
              <input formControlName="isVeteran" class="form-check-input" type="checkbox" id="selfIdentify7">
              <label class="form-check-label" for="selfIdentify">
                Veteran-Owned
              </label>
            </div>
            <div class="form-check">
              <input formControlName="isWomen" class="form-check-input" type="checkbox" id="selfIdentify8">
              <label class="form-check-label" for="selfIdentify">
                Women-Owned
              </label>
            </div>
            <div class="form-check">
              <input formControlName="isOtherMinority" class="form-check-input" type="checkbox" id="selfIdentify9">
              <label class="form-check-label" for="selfIdentify">
                Other Minority-Owned
              </label>
            </div>
            <div class="form-check">
              <input formControlName="noneOfTheAbove" class="form-check-input" type="checkbox" id="selfIdentify10">
              <label class="form-check-label" for="selfIdentify">
                None of the above
              </label>
            </div>
          </div>
        </div>

        <hr />

        <div class="row">
          <div class="col-md-6 mb-3">
            <label for="billingContact" class="form-label mb-4">Has your business received minority-owned certification
              from the city or state?</label>
            <div class="form-check">
              <input [value]="1" [formControl]="isMinorityOwnedCertifiedCtrl" [checked]="1" class="form-check-input"
                type="radio" name="billingRadio" id="billingRadio1">
              <label class="form-check-label" for="billingRadio1">
                Yes
              </label>
            </div>
            <div class="form-check">
              <input [value]="2" [formControl]="isMinorityOwnedCertifiedCtrl" [checked]="2" class="form-check-input"
                type="radio" name="billingRadio" id="billingRadio2">
              <label class="form-check-label" for="isMinorityOwnedCertifiedCtrl">
                No
              </label>
            </div>
            <div class="form-check">
              <input [value]="3" [formControl]="isMinorityOwnedCertifiedCtrl" [checked]="3" class="form-check-input"
                type="radio" name="billingRadio" id="billingRadio2">
              <label class="form-check-label" for="isMinorityOwnedCertifiedCtrl">
                Unsure
              </label>
            </div>
          </div>
          <div class="col-md-6 mb-3">

            <!-- show if yes, otherwise class d-none hides -->
            <div *ngIf="isMinorityOwnedCertified() == 1" class="row">
              <div class="col-12 mb-3">
                <label for="certSelect" class="form-label">Certification(s)</label>
                <mbsc-select class="mobi-input" formControlName="minorityOwnedCertificates" multiple
                  [data]="minorityCertificateTypes" [selectMultiple]="true">

                </mbsc-select>
                <div
                  *ngIf="minorityOwnedCertificateCtrl.invalid && (minorityOwnedCertificateCtrl.dirty || minorityOwnedCertificateCtrl.touched)">
                  <i class="fas fa-exclamation-circle"></i> This field is required when Yes is selected.
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
  <div *ngIf="currentStep == 3 && !onFinalStep">
    <div>
      <h3 *ngIf="specialAppType && specialAppType=='startup'">Silver Startup</h3>
      <h3 *ngIf="specialAppType && specialAppType=='chambercare'">ChamberCare Health Alliance</h3>
      <h2>Finalize Your Membership</h2>
    </div>
    <div>
      <form [formGroup]="stepThreeForm">
        <div class="row">
          <div class="col-md-6 mb-3">
            <label for="membershipSelect" class="form-label">Select a Membership</label>
            <select formControlName="membershipLevel" class="form-select" aria-label="membershipSelect"
              id="membershipSelect" *ngIf="specialAppType == null">
              <option value="-1">Select a membership level</option>
              <option value="1">Silver</option>
              <option value="2">Gold</option>
              <!--<option value="3">Platinum</option>-->
              <option value="4">Signature</option>
              <option value="5">Private 100</option>`
              <option value="6">Commercial Club</option>
              <option value="7">Leadership Circle</option>
            </select>
            <div *ngIf="membershipLevelCtrl.invalid && (membershipLevelCtrl.dirty || membershipLevelCtrl.touched)">
              <i class="fas fa-exclamation-circle"></i> This field is required.
            </div>
            <div *ngIf="specialAppType && specialAppType=='startup'" class="membershipTotal">
              Startup
            </div>
            <div *ngIf="specialAppType && specialAppType=='chambercare'" class="membershipTotal">
              ChamberCare Health Alliance
            </div>
          </div>
          <div class="col-md-6 mb-3">
            <label for="membershipPrice" class="form-label mb-0">Estimated Total</label>
            <div class="membershipTotal">
              {{estimatedPrice}}
            </div>
          </div>
        </div>

        <hr />
        <div>
          <div class="row">
            <div class="col-12 mb-3">
              <label for="paymentSelect" class="form-label d-block mb-2">Payment Options</label>
              <div class="btn-group paymentSelect mb-3" role="group" aria-label="Payment Type">
                <input [value]="1" [formControl]="paymentOptionsCtrl" [checked]="1" type="radio" class="btn-check"
                  name="btnPaymentSelect" id="btnPaymentSelect1" autocomplete="off" checked>
                <label class="btn btn-outline-primary" for="btnPaymentSelect1">Credit Card</label>

                <input [value]="2" [formControl]="paymentOptionsCtrl" [checked]="2" type="radio" class="btn-check"
                  name="btnPaymentSelect" id="btnPaymentSelect2" autocomplete="off">
                <label class="btn btn-outline-primary" for="btnPaymentSelect2">eCheck</label>
              </div>
              <div *ngIf="paymentOptionsCtrl.invalid && (paymentOptionsCtrl.dirty || paymentOptionsCtrl.touched)">
                <i class="fas fa-exclamation-circle"></i> This field is required.
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12 mb-3">
              <div class="paymentInputs">
                <!-- show if credit card, otherwise class d-none hides -->
                <div *ngIf="paymentOptions() == 1" class="row">
                  <div class="col-md-8 mb-3">
                    <label for="cardNo" class="form-label">Card Number</label>
                    <input formControlName="cardNumber" type="text" class="form-control" id="cardNo"
                      placeholder="Card Number" minlength="13" maxlength="16">
                    <div *ngIf="cardNumberCtrl.invalid && (cardNumberCtrl.dirty || cardNumberCtrl.touched)">
                      <i class="fas fa-exclamation-circle"></i> This field is required.
                    </div>
                  </div>
                  <div class="col-md-2 mb-3">
                    <label for="cardExp" class="form-label">Expiration</label>
                    <input formControlName="cardExpiration" type="text" mask="00/00" class="form-control" id="cardExp"
                      placeholder="MM/YY">
                    <div *ngIf="cardExpirationCtrl.invalid && (cardExpirationCtrl.dirty || cardExpirationCtrl.touched)">
                      <i class="fas fa-exclamation-circle"></i> This field is required.
                    </div>
                  </div>
                  <div class="col-md-2 mb-3">
                    <label for="cardCVV" class="form-label">CVV</label>
                    <input formControlName="cvv" type="text" class="form-control" id="cardCVV" placeholder="CVV"
                      minlength="3" maxlength="4">
                    <div *ngIf="CVVCtrl.invalid && (CVVCtrl.dirty || CVVCtrl.touched)">
                      <i class="fas fa-exclamation-circle"></i> This field is required.
                    </div>
                  </div>
                </div>
                <!-- show if ach, otherwise class d-none hides -->
                <div *ngIf="paymentOptions() == 2" class="row">
                  <div class="col-12 mb-3">
                    <label for="routingNo" class="form-label">Routing Number</label>
                    <input formControlName="routingNumber" type="text" class="form-control" id="routeNumber"
                      placeholder="Routing Number" maxlength="9">
                    <div *ngIf="routingNumberCtrl.invalid && (routingNumberCtrl.dirty || routingNumberCtrl.touched)">
                      <i class="fas fa-exclamation-circle"></i> This field is required.
                    </div>
                  </div>
                  <div class="col-12 mb-3">
                    <label for="accountNo" class="form-label">Account Number</label>
                    <input formControlName="accountNumber1" type="text" class="form-control" id="accNumber1"
                      placeholder="Account Number" maxlength="17">
                    <div *ngIf="accountNumber1Ctrl.invalid && (accountNumber1Ctrl.dirty || accountNumber1Ctrl.touched)">
                      <i class="fas fa-exclamation-circle"></i> This field is required.
                    </div>
                    <span *ngIf="accountNumbersMatchError()"><i class="fas fa-exclamation-circle"></i> Account numbers
                      do not match.</span>
                  </div>
                  <div class="col-12 mb-3">
                    <label for="accountNo2" class="form-label">Confirm Account Number</label>
                    <input formControlName="accountNumber2" type="text" class="form-control" id="accNumber2"
                      placeholder="Confirm Account Number" maxlength="17">
                    <div *ngIf="accountNumber2Ctrl.invalid && (accountNumber2Ctrl.dirty || accountNumber2Ctrl.touched)">
                      <i class="fas fa-exclamation-circle"></i> This field is required.
                    </div>
                    <span *ngIf="accountNumbersMatchError()"><i class="fas fa-exclamation-circle"></i> Account numbers
                      do not match.</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <hr />
        </div>

        <!--<div class="row">
          <div class="col-12 mb-3">
            <label for="autoRenewSelect" class="form-label mb-4">Lorem ipsum auto renew?</label>
            <div class="form-check">
              <input [value]="true" [formControl]="autoRenewCtrl" [checked]="true" class="form-check-input" type="radio" name="autoRenewRadio" id="autoRenewRadio1">
              <label class="form-check-label" for="autoRenewRadio1">
                Yes
              </label>
            </div>
            <div class="form-check">
              <input [value]="false" [formControl]="autoRenewCtrl" [checked]="false" class="form-check-input" type="radio" name="autoRenewRadio" id="autoRenewRadio2">
              <label class="form-check-label" for="autoRenewRadio2">
                No
              </label>
            </div>
          </div>
        </div>-->
        <div class="row">
          <div class="col-12 mb-3">
            <label for="declinePacDonationSelect" class="form-label mb-4">Decline PAC donation?</label>
            <div class="form-check">
              <input [value]="true" [formControl]="declinePacDonationCtrl" [checked]="true" class="form-check-input"
                type="radio" id="donateRadio1">
              <label class="form-check-label" for="donateRadio1">
                Yes
              </label>
            </div>
            <div class="form-check">
              <input [value]="false" [formControl]="declinePacDonationCtrl" [checked]="false" class="form-check-input"
                type="radio" id="donateRadio2">
              <label class="form-check-label" for="donateRadio2">
                No
              </label>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-12 mb-3">
            <div class="reviewDiv">
              <p>Thank you for completing your membership application! To finalize your membership, we need to store
                your credit card information. Rest assured, you will not be charged at this time. Your card will only be
                charged once your membership is approved and activated.</p>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-12 mb-3">
            <div class="form-check">
              <div
                *ngIf="termsAndConditionsCtrl.invalid && (termsAndConditionsCtrl.dirty || termsAndConditionsCtrl.touched)">
                <i class="fas fa-exclamation-circle"></i> This field is required.
              </div>
              <input formControlName="termsAndConditions" class="form-check-input" type="checkbox" value=""
                id="termsConditions">
              <label class="form-check-label" for="termsConditions">
                I agree to the <a href="https://IndyChamber.com/termsofservice" target="_blank">Terms and Conditions</a>
              </label>
            </div>

            <div class="form-check">
              <div *ngIf="privacyPolicyCtrl.invalid && (privacyPolicyCtrl.dirty || privacyPolicyCtrl.touched)">
                <i class="fas fa-exclamation-circle"></i> This field is required.
              </div>
              <input formControlName="privacyPolicy" class="form-check-input" type="checkbox" value=""
                id="privacyPolicy">

              <label class="form-check-label" for="privacyPolicy">
                I agree to the <a href="https://IndyChamber.com/privacypolicy" target="_blank">Privacy Policy</a>
              </label>

            </div>

          </div>
        </div>
      </form>
    </div>
  </div>

  <div *ngIf="!onFinalStep" class="actionBtns">
    <a *ngIf="currentStep > 1" (click)="stepBack()" href="javascript:void(0)" class="btn create-btn-outline"><i
        class="far fa-long-arrow-left"></i> Back</a>
    <a *ngIf="currentStep < maxStep" (click)="stepForward()" href="javascript:void(0)"
      class="btn btn-primary create-btn" style="max-width: 400px;">Next <i class="far fa-long-arrow-right"></i></a>
    <a *ngIf="currentStep == maxStep" (click)="stepForward()" class="btn btn-primary create-btn ml-2"><i
        class="far fa-check"></i> Submit</a>
    <!--<a *ngIf="currentStep < maxStep" (click)="stepForward()" class="btn btn-primary create-btn ml-2">Next <i class="far fa-long-arrow-right"></i></a>-->
  </div>
</div>
<div *ngIf="onFinalStep">
  <div class="createDiv">
    <div class="successDiv">
      <div>
        <h2 class="mb-4">Today is a big day.</h2>
      </div>
      <div class="successIcon mb-4">
        <i class="far fa-check-circle"></i>
      </div>
      <div class="fs-4 mb-5">Welcome to the Indy Chamber! Sit tight. Our membership team is processing your application
        and will send you the next steps to your inbox soon.</div>
      <div class="">
        <button type="button" (click)="finalButtonClick()" class="btn btn-lg btn-block sign-up-btn-drop">Learn more
          about Indy Chamber!</button>
      </div>
    </div>
  </div>
</div>